// extracted by css-extract-rspack-plugin
export default {"wrapper":"_64bd66bf"};